import { Card, Form, Input, message, Modal } from "antd";
import { CustomBtn } from "../../../../components/commonComponents";
import { deactiveDocument } from "../actions";
import { useAppContext } from "../../../../hooks/useAppContext";

export default function DocumentDeactivationModal({ doc, open, close, setDocToEdit, messageApi }) {
    const [form] = Form.useForm()
    const { refreshDocs } = useAppContext()

    const closeModal = () => {
        form.resetFields()
        close(false)
        if (doc) {
            setDocToEdit(null)
        }
    }

    const onFinish = async (values) => {
        deactiveDocument(doc.id, values.reason).then(() => {
            closeModal()
            refreshDocs()
            messageApi.success('დოკუმენტი გაუქმდა')
        }).catch((error) => {
            messageApi.error(error.message)
        })
    }
    return (
        <Modal
            open={open}
            onCancel={() => {
                closeModal()
                refreshDocs()
            }}
            title='დოკუმენტის დეაქტივაცია'
            footer={[
                <CustomBtn key='submit' onClick={form.submit} label={'დეაქტივაცია'} color='#eb2f96' htmlType="submit" icon={<i className="fa-solid fa-ban" style={{ color: 'white', fontSize: 22, }}></i>} />,
                <CustomBtn key='cancel' onClick={closeModal} label={'დახურვა'} color='#8c8c8c' htmlType="button" icon={<i className="fa-solid fa-xmark" style={{ color: 'white', fontSize: 22, }}></i>} />
            ]}
        >
            <Card
                title={doc?.department + '-' + doc?.hierarchy + '-' + doc?.number}
            >
                <Form
                    form={form}
                    onFinish={onFinish}
                    layout='vertical'
                >
                    <Form.Item
                        label='დოკუმენტის დეაქტივაციის მიზეზი'
                        name='reason'
                        rules={[{ required: true, message: 'დოკუმენტის დეაქტივაციის მიზეზი არის სავალდებულო' }]}
                    >
                        <Input.TextArea rows={4} />
                    </Form.Item>
                </Form>
            </Card>
        </Modal>
    )
}